module.exports = __webpack_public_path__ + "img/lianxiwomenbanner.f55de7c5.png";